var React = require('react');

function Jamstack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.5 0h132v147H.5z","key":0}),React.createElement("path",{"d":"M64.2 25.23c-26.802 0-48.47 21.668-48.47 48.47s21.668 48.47 48.47 48.47 48.47-21.668 48.47-48.47V25.23H64.2Z","fill":"currentColor","key":1}),React.createElement("path",{"d":"M62.633 75.2v33.985C44.24 108.407 29.427 93.595 28.65 75.2h33.984ZM65.7 75.267h33.985C98.906 93.66 84.094 108.473 65.7 109.25V75.267ZM65.7 72.133V38.131h34.002v34.002H65.7Z","fill":"#fff","stroke":"currentColor","key":2})]);
}

Jamstack.defaultProps = {"viewBox":"0 0 133 147","fill":"none"};

module.exports = Jamstack;

Jamstack.default = Jamstack;
